__webpack_require__.p = "/black-desert-tool/";